import React from "react";
import { Link } from "react-router-dom";
import "../styles/privacy_policy.css";

const SUPPORT_EMAIL = "isfinformaticaanalytica@gmail.com";

const CancellationPolicy = () => {
  return (
    <div className="privacy-policy-container">
      <div className="privacy-policy-content">
        <h1 className="privacy-title">Cancellation Policy for Skill Master</h1>
        <p className="last-updated">Last updated: November 5, 2026</p>

        <p className="intro-text">
          This Cancellation Policy applies to all orders placed on Skill Master (skillmaster.net.in),
          operated by ISF Analytica &amp; Informatica Pvt. Ltd. ("we", "our", or "us"). Skill Master
          sells digital learning content that is delivered to your account as soon as your payment
          is successful.
        </p>

        <section className="policy-section">
          <h2 className="section-title">1. Before Payment</h2>
          <p>
            You can cancel at any time before completing the payment. Items in your cart or wishlist
            are not orders and can be removed whenever you like. If you close or go back from the
            payment page without paying, no order is placed and no amount is charged.
          </p>
        </section>

        <section className="policy-section">
          <h2 className="section-title">2. After Payment</h2>
          <p>
            Since the content is unlocked in your account immediately after a successful payment,
            an order cannot be cancelled once the payment is complete.
          </p>
          <p>
            If you were charged but the content was not unlocked, or you were charged twice for the
            same item, you are eligible for a refund as described in our{" "}
            <Link to="/refund_policy">Refund Policy</Link>.
          </p>
        </section>

        <section className="policy-section">
          <h2 className="section-title">3. Pending Payments</h2>
          <p>
            If your payment shows as pending, do not pay again. Wait for the status to update, or
            contact us with the Transaction ID. If the payment is not completed, any amount debited is
            reversed automatically by your bank or our payment partner within 5 to 7 working days.
          </p>
        </section>

        <section className="policy-section">
          <h2 className="section-title">4. Cancellation by Skill Master</h2>
          <p>We may cancel an order and refund the full amount if:</p>
          <ul className="policy-list">
            <li>The content is no longer available or cannot be delivered.</li>
            <li>The price or product details were shown incorrectly because of a technical error.</li>
            <li>We detect a fraudulent or unauthorised transaction.</li>
          </ul>
          <p>In such cases the refund is made to the original payment method.</p>
        </section>

        <section className="policy-section">
          <h2 className="section-title">5. Account Closure</h2>
          <p>
            You can ask us to close your Skill Master account at any time by emailing us. Closing an
            account does not make past purchases refundable, and access to purchased content ends
            when the account is closed.
          </p>
        </section>

        <section className="policy-section">
          <h2 className="section-title">6. How to Contact Us</h2>
          <p>
            For any cancellation request or question, email{" "}
            <a href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</a> with your registered email
            address, the item name, and the Transaction ID. We respond within 2 working days.
          </p>
          <div className="contact-info">
            <p><strong>ISF Analytica &amp; Informatica Pvt. Ltd.</strong></p>
            <p>Chembur, Mumbai, Maharashtra, India</p>
            <p>Email: <a href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</a></p>
            <p>Website: <a href="https://skillmaster.net.in" target="_blank" rel="noopener noreferrer">https://skillmaster.net.in</a></p>
          </div>
        </section>

        <section className="policy-section">
          <h2 className="section-title">7. Changes to This Policy</h2>
          <p>
            We may update this Cancellation Policy from time to time. The version published on this
            page at the time of your purchase applies to that purchase.
          </p>
        </section>
      </div>
    </div>
  );
};

export default CancellationPolicy;
